import { useEffect } from 'react';
import { Web3SecondHeader } from '@web3fe/infra';
import { scTrack } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';

import { Banner } from './Banner';
import clsx from 'clsx';
import styles from './style.module.less';
import Winner from './Winner';
import { Content } from './Content';
import useHomeStore from '@/store/home';
import { TermNConditions } from './TermNConditions';

export const HomePage = () => {
  const { fetchWalletConfig } = useHomeStore();
  useEffect(() => {
    scTrack(Event.Web3PageView, {
      page_name: Page.HomePage,
    });
    fetchWalletConfig();
  }, []);
  return (
    <div className={clsx(styles['home-wrap'], 'pb-18 md:pb-36')}>
      <div className="main">
        <Web3SecondHeader />
      </div>
      <Banner />
      <Winner />
      <Content />
      <TermNConditions />
    </div>
  );
};
